var __awaiter = (this && this.__awaiter) || function (thisArg, _arguments, P, generator) {
    function adopt(value) { return value instanceof P ? value : new P(function (resolve) { resolve(value); }); }
    return new (P || (P = Promise))(function (resolve, reject) {
        function fulfilled(value) { try { step(generator.next(value)); } catch (e) { reject(e); } }
        function rejected(value) { try { step(generator["throw"](value)); } catch (e) { reject(e); } }
        function step(result) { result.done ? resolve(result.value) : adopt(result.value).then(fulfilled, rejected); }
        step((generator = generator.apply(thisArg, _arguments || [])).next());
    });
};
import { jsx as _jsx, jsxs as _jsxs, Fragment as _Fragment } from "react/jsx-runtime";
import React from 'react';
import { useTranslation } from 'react-i18next';
import styles from './style.module.scss';
import { Button, Loader, Select } from '../index';
import { toast } from 'react-toastify';
import { useHttp } from '../../hooks/useHttp';
const ModalWindowUpdate = ({ hideModal, updateDiscipline, formSelect, groups, credit, idSemester, }) => {
    const { t } = useTranslation();
    const { request } = useHttp();
    const [loader, setLoader] = React.useState(true);
    const [teachers, setTeachers] = React.useState([]);
    const [flows, setFlows] = React.useState([]);
    const [value, setValue] = React.useState({
        teacher: '',
        flow: '',
    });
    const changeTeacher = (e) => {
        setValue(Object.assign(Object.assign({}, value), { teacher: e.target.value }));
        getFlows2(e.target.value);
    };
    const changeFlow = (e) => setValue(Object.assign(Object.assign({}, value), { flow: e.target.value }));
    const click = () => {
        if (value.flow.length && value.teacher.length) {
            return updateDiscipline(value.flow, value.teacher);
        }
        toast.warn(t('warnInput'));
    };
    const getTeachers = () => __awaiter(void 0, void 0, void 0, function* () {
        const group = groups.find((item) => item.id_group == Number(formSelect.group));
        const { data } = yield request(`/teacher-for-update?id_year=${formSelect.year}&id_kafedra=${formSelect.kafedra}&id_w_s=${formSelect.ws}&id_semester=${idSemester}&id_faculty=${formSelect.faculty}&id_discipline=${formSelect.discipline}&id_f_educ=${group === null || group === void 0 ? void 0 : group.id_f_educ}&kredit=${credit}`);
        setLoader(false);
        setTeachers(data);
    });
    const getFlows2 = (id_teacher) => __awaiter(void 0, void 0, void 0, function* () {
        const group = groups.find((item) => item.id_group == Number(formSelect.group));
        const { data } = yield request(`/flow2?id_discipline=${formSelect.discipline}&id_year=${formSelect.year}&id_examination=${formSelect.formControl}&id_w_s=${formSelect.ws}&id_kafedra=${formSelect.kafedra}&id_teacher=${id_teacher}&id_o_z=${group === null || group === void 0 ? void 0 : group.o_z}&id_f_educ=${group === null || group === void 0 ? void 0 : group.id_f_educ}&kredit=${credit}&id_faculty=${formSelect.faculty}`);
        setFlows(data);
    });
    React.useEffect(() => {
        getTeachers();
    }, []);
    return (_jsx("div", Object.assign({ className: styles.container }, { children: _jsxs("div", Object.assign({ className: styles.modal }, { children: [_jsxs("div", Object.assign({ className: styles.head }, { children: [_jsx("h2", { children: t('change') }), _jsx("i", { className: "fa-solid fa-xmark", onClick: hideModal })] })), _jsx("div", Object.assign({ className: styles.body }, { children: loader ? (_jsx("div", Object.assign({ className: "d-flex justify-content-center align-items-center" }, { children: _jsx(Loader, { type: "text-primary" }) }))) : (_jsxs(_Fragment, { children: [_jsx(Select, { label: t('teacher'), margin: "10px", width: "100%", name: "teacher", options: teachers.map((item) => ({ value: item.id_teacher, label: item.t_fio })), change: changeTeacher }), _jsx(Select, { label: t('flow'), margin: "10px", width: "100%", name: "flow", options: flows.map((item) => ({ value: item.subgroup, label: item.subgroupAndName })), change: changeFlow }), _jsx("div", Object.assign({ className: "mt-4" }, { children: _jsx(Button, { onClick: click, value: t('change'), icon: _jsx("i", { className: "fa-solid fa-arrows-rotate" }) }) }))] })) }))] })) })));
};
export default ModalWindowUpdate;
